import { channel_manager } from '../actions/channel_manager';
import { stories } from '../actions/stories';
import { enterprise } from '../actions/enterprise';
import mediaStorageReducer from './media_storage';
import mwLinksReducer from './mw_links';
import keywordEventsReducer from './keyword_events';
import setForms from './forms';
import { paginatedCustomers } from './paginatedCustomers';
import { waTemplates } from './waTemplates';
import featureFlags from './featureFlags';
import unreadMessagesReducer from './unread_messages';
import { conversationsReducer } from './conversations';
import { sessionTimerReducer } from './sessionTimer';
import { modalReducer } from './modals';
import { notificationMessagesReducer } from './notificationStatus';
import { paginatedTemplates } from './paginatedTemplates';
import permissions from './permissions';
import { global } from './global';
import { user } from './user';

const rootReducer = {
  channel_manager,
  stories,
  enterprise,
  global,
  user,
  media_storage: mediaStorageReducer,
  mw_links: mwLinksReducer,
  keyword_events: keywordEventsReducer,
  forms: setForms,
  paginated_customers: paginatedCustomers,
  wa_templates: waTemplates,
  featureFlags,
  sessionTimer: sessionTimerReducer,
  modals: modalReducer,
  unread_messages: unreadMessagesReducer,
  conversations: conversationsReducer,
  notificationStatus: notificationMessagesReducer,
  paginatedTemplates,
  permissions,
};

export default rootReducer;
